import { render, staticRenderFns } from "./personSchemeRentInfo.vue?vue&type=template&id=70244698&scoped=true"
import script from "./personSchemeRentInfo.vue?vue&type=script&lang=js"
export * from "./personSchemeRentInfo.vue?vue&type=script&lang=js"
import style0 from "./personSchemeRentInfo.vue?vue&type=style&index=0&id=70244698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70244698",
  null
  
)

export default component.exports